<template>
<div class='price'>
  <div class='banner'>
    <div class='bg'></div>
    <div class='bg2'></div>
    <div class='content'>
      <div class='title'>2.0&nbsp;&nbsp;全新发布</div>
      <div class='frame'>
        <div class='section left'>
          <p class='large'>免费不限量</p>
          <p>个人用户</p>
          <p>不限量临时项目</p>
          <p>适合短时分享</p>
        </div>
        <div class='section right'>
          <p class='large'>会员新升级</p>
          <p>专业用户和企业客户</p>
          <p>正式场景，专业需求</p>
          <p>专属会员特权</p>
        </div>
        <i class='ppj-icon-cancel-thin'></i>
      </div>
    </div>
  </div>

  <div class='sub-banner'>
    <div class='bg'></div>
    <div class='content'>
      <h1>价格方案</h1>
      <p class='sub'>升级会员获得充足的项目额度，满足专业需求，享受贴心服务</p>
    </div>
  </div>

  <div class='cards'>
    <div class='card' :class="{prefer: product.prefer}" v-for="product in products" :key="product.type" v-once>
      <div class='header'>
        <p class='product-name'>
          {{product.name}}
          <span class='recommand' v-if='product.prefer'>推荐</span>
        </p>
        <p class='product-price'>
          <span class='em' v-if="product.price === 0">免费</span>
          <span v-else class='price'>
            <span class='em'>{{product.price}}</span> /年
          </span>
        </p>
        <el-button class='prouct-action' v-if="product.type === 'beta'" :disabled="Boolean(session)" @click="$router.push('/register')">
          {{session ? '已获得' : '立即注册'}}
        </el-button>
        <!-- <el-button class='prouct-action' v-else-if="product.type === 'professional'" @click="contactUs">联系我们</el-button> -->
        <el-button class='prouct-action' @click="purchase(product.type)" v-else>立即购买</el-button>
      </div>
      <div class='details feature'>
        <p>
          项目额度
          <el-tooltip effect="dark" :content="$t('tooltips.permanent')" :popper-options="{removeOnDestroy: true}" :open-delay="200">
            <span class='em' data-type='permanent' v-if="product.permanent === 0">￥49</span>
            <span class='em' data-type='permanent' v-else>{{product.permanent === null ? '不限个数' : product.permanent}}</span>
          </el-tooltip>
          <span v-if="product.permanent === 0">/个</span>
          <span v-if="product.permanent">个</span>
        </p>
        <p>
          导出
          <el-tooltip effect="dark" :content="$t('tooltips.export')" :popper-options="{removeOnDestroy: true}" :open-delay="200">
            <span class='em' :class="{'price': product.export}" data-type='export'>{{product.export === null ? '免费' : product.export}}</span>
          </el-tooltip>
          <span v-if="product.export">/个</span>
        </p>
        <p>自定义LOGO
          <el-tooltip effect="dark" :content="$t('tooltips.logo')" :popper-options="{removeOnDestroy: true}" :open-delay="200">
            <span class='em' :class="{'price': product.logo}" data-type='logo'>{{product.logo === null ? '免费' : product.logo}}</span>
          </el-tooltip>
          <span v-if="product.logo">/个</span>
        </p>
        <p v-if='product.sub_account'>
          子账号
          <el-tooltip effect="dark" :content="$t('tooltips.subAccount')" :popper-options="{removeOnDestroy: true}" :open-delay="200">
            <span class='em' data-type='subAccount'>{{product.sub_account}}</span>
          </el-tooltip>
          个
        </p>
        <p v-if='product.custom_domain'>支持独立域名</p>
      </div>
      <div class='cdn feature'>
        <div class='line'></div>
        <p>
          CDN流量
          <el-tooltip effect="dark" :content="$t('tooltips.cdn')" :popper-options="{removeOnDestroy: true}" :open-delay="200">
            <span class='em cdn' data-type='cdn'>{{product.cdn_amount}}</span>
          </el-tooltip>
          /年
        </p>
        <p v-if="product.custom_queue">专用转换队列</p>
        <p v-if="product.custom_encryption">企业级请求加密</p>
        <p v-if="product.custom_cdnspeedup">CDN优化加速</p>
        <p v-if="product.custom_cs">专属客服</p>
        <p v-if="product.online_tutor2">赠送1次线上培训</p>
      </div>
      <div class='log feature'>
        <div class='line'></div>
        <!--
        <p>
          日志保留
          <el-tooltip effect="dark" :content="$t('tooltips.log')" :popper-options="{removeOnDestroy: true}" :open-delay="200">
            <span class='em' data-type='log'>{{product.log_retain_days ? `${product.log_retain_days}天` : '永久'}}</span>
          </el-tooltip>
        </p>
        -->
        <p>
          数据报告
          <el-tooltip effect="dark" :content="$t('tooltips.report')" :popper-options="{removeOnDestroy: true}" :open-delay="200">
            <span class='em' data-type='report'>{{$t(`reportType.${product.report_type}`)}}</span>
          </el-tooltip>
        </p>
        <p v-if="product.data_export">数据导出</p>
      </div>
      <div class='remark feature'>
        <div class='line'></div>
        <p>表单答题</p>
        <p>微信录音</p>
        <p>音视频</p>
        <p v-if='product.wxpay'>付费阅读</p>
        <p v-if='product.wechat_support'>公众号推广</p>
      </div>
    </div>
  </div>

  <!--
  <div class='footer'>
    <div class='teacher'>
      <router-link to='/teacher'><i class='ppj-icon-graduation'></i>教育发展计划公布！点击领取老师专属福利</router-link>
    </div>
    <div class='details'>
      <p>说明</p>
      <p>1. 所有用户均可免费创建不限数量的临时项目，如需创建永久项目请购买额度或会员套餐。</p>
      <p>2. 临时项目不限量，在生成 8小时内不限浏览，之后观看需要支付 1元。<a class='text-btn' href='/faq/permanent' target='_blank'>了解详情</a></p>
    </div>
  </div>
  -->
</div>
</template>

<style lang='scss' scoped>
.price {
    font-size: 13px;
    min-height: $min-height-base;
    width: 100%;
    padding-top: 1px;

    .banner {
        min-width: $page-width-small;
        width: 100%;
        background: #FFFBF3;
        position: relative;
        padding-top: 55px;
        padding-bottom: 70px;
        padding-top: 30px;

        .bg {
            position: absolute;
            background-image: url('/static/images/svg/bottom-background.svg');
            background-size: cover;
            background-repeat: no-repeat;
            height: 125px;
            width: 100%;
            bottom: 70px;
        }

        .bg2 {
            position: absolute;
            z-index: 1;
            background: #ffe3a8;
            background: linear-gradient(to bottom, #ffe3a8, #FFD4A9);
            width: 100%;
            height: 70px;
            bottom: 0;
        }

        .content {
            width: $page-width-small;
            margin: 0 auto;
            text-align: center;
            position: relative;
            z-index: 2;

            .title {
                font-size: 32px;
                color: #F5882A;
            }

            .frame {
                width: 500px;
                height: 200px;
                margin: 50px auto 0;
                background: #FBBF72;
                background: linear-gradient(to bottom,#FBBF72, #E56F3B);
                border-radius: 100px;
                overflow: hidden;
                position: relative;
                .section {
                    width: 50%;
                    float: left;
                    padding-top: 30px;

                    &.left {
                        text-align: right;
                        padding-right: 30px;

                        .large {
                            margin-right: -8px;
                        }
                    }

                    &.right {
                        text-align: left;
                        padding-left: 30px;
                        position: relative;

                        .large {
                            margin-left: -8px;
                        }
                        &:before {
                            content: '';
                            display: block;
                            width: 1px;
                            height: 50px;
                            background-color: #fff;
                            opacity: 0.5;
                            position: absolute;
                            left: 0;
                            top: 100px;
                        }
                    }

                    p {
                        color: $color-white-base;
                        font-size: 15px;
                        margin: 0.5em 0;
                        &.large {
                            font-size: 24px;
                            font-weight: bold;
                            margin-bottom: 1em;
                        }
                    }
                }

                .ppj-icon-cancel-thin {
                    color: #fff;
                    opacity: 0.5;
                    position: absolute;
                    left: 50%;
                    width: 20px;
                    text-align: center;
                    margin-left: -10px;
                    top: 50px;
                }
            }
        }
    }

    .sub-banner {
        width: 100%;
        padding: 50px;
        text-align: center;
        background: #fafafa;
        height: 400px;
        position: relative;
        .bg {
            background-image: url('/static/images/price-bg3.png');
            position: absolute;
            background-size: cover;
            background-repeat: no-repeat;
            height: 400px;
            width: 100%;
            top: 0;
            left: 0;
            border-bottom: 1px solid #eee;
        }

        .content {
            z-index: 1;
            position: relative;

            h1 {
                font-size: 32px;
            }

            .sub {
                font-size: 18px;
                color: #333;
                margin: 40px 0;
            }

            .discount {
                font-size: 14px;
                color: white;
                background-color: #222;
                padding: 5px 10px;
            }
        }
    }

    .hint-wrapper {
        width: $page-width-small;
        margin: 0 auto 15px;
    }

    .cards {
        width: $page-width-small;
        margin: 0 auto;
        box-shadow: $box-shadow-base;
        border: $border-base;
        overflow: hidden;
        z-index: 3;
        position: relative;
        margin-top: -90px;

        .card {
            width: 20%;
            float: left;
        }
    }

    .card {
        overflow: hidden;
        background: $color-white-base;

        p,
        span {
            cursor: default;
            white-space: nowrap;
        }

        .header {
            text-align: center;
            .product-name {
                font-color: $font-color-strong;

                .recommand {
                    $arror-width: 4px;
                    &:before {
                        content: '';
                        position: absolute;
                        display: block;
                        left: -2 * $arror-width;
                        top: 7px;
                        width: 0;
                        height: 0;
                        border-color: transparent;
                        border-style: solid;
                        border-width: $arror-width;
                        border-right-color: $color-primary;

                    }
                    display: inline-block;
                    position: absolute;
                    margin-left: 10px;
                    border-radius: 1px;
                    background: $color-primary;
                    line-height: 16px;
                    padding: 3px 6px;
                    margin-top: -3px;
                    color: $color-white-base;
                }
            }
            .product-price {
                line-height: 4em;
                height: 4em;
                .em {
                    font-size: $font-size-large;
                    color: $font-color-strong;
                }

                .price {
                    &:before {
                        content: '￥';
                        vertical-align: super;
                    }
                }
            }
            padding: 10px 0 30px;
            border-bottom: $border-base;
        }

        .feature {
            padding: 10px 20px;
            color: $font-color-light;
            .line {
                border-top: $border-base;
            }

            .em {
                color: $font-color-strong;
                margin: 0 0.4em;

                &.price {
                    &:before {
                        content: '￥';
                    }
                }

                &.cdn {
                    &:after {
                        content: ' GB';
                    }
                }

                &.hover {
                    color: $color-primary;
                    text-decoration: underline;
                }
            }

            &.details {
                height: 170px;
            }

            &.cdn {
                height: 190px;
            }

            &.log {
                height: 110px;
            }

            &.remark {
                height: 180px;
            }
        }

        &.prefer {
            position: relative;
            z-index: $index-normal;
            box-shadow: $box-shadow-dark;

            .header {
                border-color: $color-primary;
                border-width: $border-width-thick;
                padding-bottom: 30px - 1px;
            }
        }
    }

    .footer {
        text-align: center;
        width: $page-width-small;
        margin: 0 auto;

        .teacher {
            font-size: 14px;
            margin: 45px 0;

            i {
                margin-right: 0.5em;
                font-size: 1.5em;
            }

            a {
                color: #333;
                &:hover {
                    color: #f5882a;
                }
            }
        }

        .details {
            text-align: left;
            color: #333;
            padding-left: 50px;

            p {
                font-size: 13px;
                margin: 0;
                line-height: 1.8;
            }
        }
    }
}
</style>

<script>
import packages from '@/config/packages'
// i18n setting locale i18n
let i18n = {
  messages: {
    'zh-cn': {
      reportType: {
        base: '基础',
        advanced: '高级'
      },
      tooltips: {
        permanent: '超出套餐包含的永久项目，按照 49 元/个收费',
        export: '超出套餐包含的导出功能，按照 120 元/次收费',
        logo: '超出套餐包含的自定义 Logo 功能，按照 99 元/次收费',
        subAccount: '企业拥有的最大子账号数量',
        cdn: '由PP匠提供的网页流量，超出部分按照 1 元/GB 收费',
        log: '可通过专用接口获得项目的访问日志',
        report: 'PP匠提供网页大数据分析'
      }
    }
  }
}

const addClass = (elem, className) => {
  if (elem.classList) {
    elem.classList.add(className)
  } else {
    if (elem.className.indexOf(className) === -1) {
      elem.className = elem.className + ' ' + className + ' '
    }
  }
}

const hasClass = (elem, className) => {
  if (elem.classList) {
    return elem.classList.contains(className)
  } else {
    return elem.className.indexOf(className) > -1
  }
}

const removeClass = (elem, className) => {
  if (elem.classList) {
    elem.classList.remove(className)
  } else {
    if (hasClass(elem, className)) {
      elem.className = elem.className.replace(new RegExp('(\\s|^)' + className + '(\\s|$)'), ' ').replace(/^\s+|\s+$/g, '')
    }
  }
}

let mouseenter = e => {
  let elem = e.target
  if (!hasClass(elem, 'em')) return

  let type = (e.target.dataset && e.target.dataset.type) || e.target.getAttribute('data-type')
  if (!type) return

  let elements = document.querySelectorAll("span.em[data-type='" + type + "']")
  for (let i = 0; i < elements.length; i++) {
    addClass(elements[i], 'hover')
  }
}

let mouseleave = e => {
  let elem = e.target
  if (!hasClass(elem, 'em')) return

  let type = (e.target.dataset && e.target.dataset.type) || e.target.getAttribute('data-type')
  if (!type) return

  let elements = document.querySelectorAll("span.em[data-type='" + type + "']")
  for (let i = 0; i < elements.length; i++) {
    removeClass(elements[i], 'hover')
  }
}

export default {
  data() {
    return {
      products: packages.filter(i => i.show !== false),
      hover: null
    }
  },
  computed: {
    session() {
      return this.$store.getters['user/session']
    },
    curPackage() {
      let vm = this
      let list = vm.$store.state.quota.list
      if (!vm.session || list.length <= 0) {
        return null
      }

      list.forEach(item => {
        if (['yearly_basic', 'yearly_pro', 'yearly_enterprise'].indexOf(item['package']) >= 0) {
          return item['package']
        }
      })

      return null
    }
  },
  methods: {
    purchase(_type) {
      let vm = this

      if (!vm.session) {
        vm.$alert('请先登录后购买').then(_ => {
          vm.$router.push({
            path: '/login',
            query: {
              returnTo: '/price'
            }
          })
        })
        return
      }

      if (vm.curPackage) {
        vm.$alert('您已经购买了某一款套餐，暂时不支持升降级。如需转化套餐模式请联系我们')
        return
      }

      vm.$router.push({
        name: 'order',
        query: {
          type: _type
        }
      })
    }
  },
  i18n,
  mounted() {
    this.$el.addEventListener('mouseenter', mouseenter, true)
    this.$el.addEventListener('mouseleave', mouseleave, true)
  },
  beforeDestroy() {
    this.$el.removeEventListener('mouseenter', mouseenter, true)
    this.$el.removeEventListener('mouseleave', mouseleave, true)
  }
}
</script>



// WEBPACK FOOTER //
// index.vue?15e9e066